import script from "./BlockSocialNetworks.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockSocialNetworks.vue?vue&type=script&setup=true&lang=js"

import "./BlockSocialNetworks.vue?vue&type=style&index=0&id=11f540f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f540f8"]])

export default __exports__